const Helpful = () => {
  return (
    <div className="helpful-links" id="helpful-link">
      <div className="helpful-links-title">HELPFUL LINKS</div>
      <div className="helpful-links-detail">
        <div className="helpful-links-logo">
          <img src="assets/img/california.png" alt="" />
        </div>
        <div className="helpful-links-dec">
          <div className="helpful-links-subtitle">
            California Legislative Action Committee
          </div>
          <div className="helpful-dec-section">
            The California Legislative Action Committee (CLAC) is a committee of
            the Community Associations Institute (CAI). It is the largest
            advocacy organization in America dedicated to monitoring
            legislation, educating elected state lawmakers, and protecting the
            interests of those living in community associations in California.
          </div>
          <div className="helpful-link"><a href="https://www.clac.org" className="custom_link" target="_blank">www.clac.org</a></div>
        </div>
      </div>
      <div className="information">
        <div className="information-detail">
          <div className="information-title">
            Official California Legislation <br /> Information
          </div>
          <div className="information-dec">
            This link will allow you to look up and subscribe to bills as they
            make their way through the legislature. Just click on Legislation.
            You can also find California Codes, Statutes, and the California
            Constitution from the Legislation page.
          </div>
          <div className="information-link"><a href="https://leginfo.legislature.ca.gov" className="custom_link" target="_blank">leginfo.legislature.ca.gov</a></div>
        </div>
        <div className="information-logo">
          <img src="assets/img/official.png" alt="" />
        </div>
      </div>
      <div className="community-associations-card-section">
        <div className="community-associations-card">
          <div className="community-associations">
            <div className="community-associations-name">
              Community Associations Institute (CAI) <br /> Channel Islands
              Chapter <br /> Chapter Executive Director
            </div>
            <div className="community-associations-position">
              Leah Ross <br /> P.O. Box 3575 <br />
              Ventura, CA 93001 <br />
              (805) 658-1438
            </div>
            <div className="community-associations-link">
              <a href="https://www.cai-channelislands.org" className="custom_link" target="_blank">www.cai-channelislands.org</a>
            </div>
          </div>
          <div className="border-div"></div>
        </div>
        <div className="community-associations-card active-bg">
          <div className="community-associations">
            <div className="community-associations-name">Community Associations Institute (CAI) <br />Greater Los Angeles Chapter (GLAC)</div>
            <div className="community-associations-position">
              2341 Broadway <br />Eagle Rock, CA 90041 <br />(323) 254-9526
            </div>
            <div className="community-associations-link">
              <a href="https://www.cai-glac.org" className="custom_link" target="_blank">www.cai-glac.org</a>
            </div>
          </div>
          <div className="border-div"></div>
        </div>
        <div className="community-associations-card">
          <div className="community-associations">
            <div className="community-associations-name">California Association of Community Managers (CACM)</div>
            <div className="community-associations-position">
              18662 MacArthur Blvd., Suite 340 <br />Irvine, CA 92612 <br />(949) 263-2226
            </div>
            <div className="community-associations-link">
              <a href="https://www.cacm.org" className="custom_link" target="_blank">www.cacm.org</a>
            </div>
            <div className="underline-bar"></div>
          </div>
          <div className="border-div"></div>
        </div>
      </div>
    </div>
  );
};

export default Helpful;
